import './grid-line-indicators.scss';

interface Props {
    children?: React.ReactNode;
}

const GridLineIndicators: React.FC<Props> = ({ children }) => {
    return (
        <div className="grid-line-indicators">
            {children}
        </div>
    );
}

export default GridLineIndicators;
